import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { MedicalSpecialtyRepository } from './repository';
import type {
  GetAllMedicalSpecialtiesOutput,
  GetAllMedicalSpecialtiesResponse,
} from './types/getAll.type';

class MedicalSpecialtyService implements MedicalSpecialtyRepository {
  public async getAll(): Promise<GetAllMedicalSpecialtiesOutput> {
    const response =
      await backendHttpClient.get<GetAllMedicalSpecialtiesResponse>({
        path: 'medical-specialties',
      });

    const output: GetAllMedicalSpecialtiesOutput = {
      list: response.data.list,
    };
    return output;
  }
}

export const medicalSpecialtyService = new MedicalSpecialtyService();
